import { Badge } from '@/components/ui/badge'
import { cn } from '@/utils/cn'
import { ALERT_CLASSES, PRIORITY_CLASSES, type TaskView } from '@/lib/tasks-board'

/** Selo de prazo calculado no servidor: vencida (vermelho), hoje (laranja), ≤ 3 dias (amarelo). */
export function TaskAlertBadge({ task }: { task: Pick<TaskView, 'alerta'> }) {
  if (!task.alerta) return null
  return (
    <Badge className={cn('border-transparent', ALERT_CLASSES[task.alerta.cor])} data-alerta={task.alerta.nivel}>
      {task.alerta.texto}
    </Badge>
  )
}

export function TaskPriorityBadge({ task }: { task: Pick<TaskView, 'prioridade'> }) {
  return (
    <Badge variant="outline" className={PRIORITY_CLASSES[task.prioridade]}>
      {task.prioridade}
    </Badge>
  )
}

/** Selos complementares: em revisão, retorno do Aguardando, agente. */
export function TaskExtraBadges({ task }: { task: Pick<TaskView, 'em_revisao' | 'retorno_alerta' | 'etapa' | 'status'> }) {
  return (
    <>
      {task.em_revisao && <Badge variant="secondary">Em revisão</Badge>}
      {task.retorno_alerta && <Badge variant="secondary">{task.retorno_alerta}</Badge>}
      {task.etapa === 'ARQUIVADA' && task.status === 'CANCELLED' && <Badge variant="outline">Cancelada</Badge>}
    </>
  )
}
